import { render, staticRenderFns } from "./InspectionRemarkAttachment.vue?vue&type=template&id=35886c6b&scoped=true&"
import script from "./InspectionRemarkAttachment.vue?vue&type=script&lang=js&"
export * from "./InspectionRemarkAttachment.vue?vue&type=script&lang=js&"
import style0 from "./InspectionRemarkAttachment.vue?vue&type=style&index=0&id=35886c6b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35886c6b",
  null
  
)

export default component.exports